export default __webpack_public_path__ + "static/media/sanguineinfusion.d2e9259b.png";